// https://www.npmjs.com/package/react-tag-autocomplete
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import ReactTags from 'react-tag-autocomplete';
import { getTagsList } from '../../../../actions/shop';

import './Tags.css';

class TagsField extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      tagIds: [],
      tags: [],
    }
  }

  componentDidMount() {
    this.props.getTagsList(this.props.type)
      .then((response) => {
        if (this.props.input.value){
          const tagIds = this.props.input.value;
          const tags = response.filter(i => tagIds.includes(i.id));

          this.setState({ tags, tagIds });
          this.props.input.onChange(tagIds);
        }
      });
  }

  handleDelete = i => {
    const tagIds = this.state.tagIds.slice(0);
    tagIds.splice(i, 1);
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);

    this.setState({ tagIds, tags });
    this.props.input.onChange(tagIds);
  }

  handleAddition = tag => {
    if (!this.state.tagIds.includes(tag.id) && this.state.tags.length < this.props.max_amount){
      const tagIds = [].concat(this.state.tagIds, tag.id);
      const tags = [].concat(this.state.tags, tag);
      this.setState({ tags, tagIds });
      this.props.input.onChange(tagIds);
    }
  }

  handleClick = event => {
    const link = event.currentTarget;
    const tag = {
      'id': parseInt(link.getAttribute('data-id')),
      'name': link.innerText
    }
    this.handleAddition(tag);
  }

  render () {
    const { input, meta, label, helptext, placeholder, required } = this.props;
    let validate_class = '';
    if (meta.touched){
      meta.error ? validate_class = 'is-invalid' : validate_class = 'is-valid';
    }

    const tagList = this.props.suggestions.map(t => <Button variant='link' key={ t.id } data-id={ t.id }
                                                            size='sm' className='small p-0 mr-2'
                                                            onClick={ this.handleClick }>{ t.name }</Button>)

    return <Form.Group controlId={ name + '_id' }>
      { label ? <Form.Label>{ label }{ required ? ' *' : '' }</Form.Label> : '' }
      <ReactTags
        placeholder={ placeholder }
        classNames={{root: 'react-tags' + ' ' + validate_class}}
        autofocus={ false }
        tags={ this.state.tags }
        suggestions={ this.props.suggestions }
        handleDelete={ this.handleDelete }
        handleAddition={ this.handleAddition }
        handleFocus={ input.onFocus }
        handleBlur={ input.onBlur }/>
      <div>{ tagList }</div>
      { helptext ? <Form.Text className="text-muted">{ helptext }</Form.Text> : '' }
      { (meta.touched && meta.error) && <Form.Control.Feedback type="invalid">{ meta.error }</Form.Control.Feedback> }
      </Form.Group>
  }
}

let mapStateToProps = (state) => {
  return {
    suggestions: state.shop.tags
  }
};

export default compose(
  connect(mapStateToProps, { getTagsList }),
)(TagsField);

